import React from 'react';
import './AuthModal.css';
import { useNavigate } from 'react-router-dom';

const AuthModal = ({ show, isOpen, onClose, packageData }) => {
  const navigate = useNavigate();
  // Support both `show` and `isOpen` prop names
  const open = typeof isOpen === 'boolean' ? isOpen : show;
  if (!open) return null;
  
  const handleLogin = () => {
    if (packageData) {
      const packageParams = new URLSearchParams({
        plan: packageData.plan,
        duration: packageData.duration,
        price: packageData.price.toString(),
        returnTo: 'booking'
      });
      navigate(`/login?${packageParams.toString()}`);
    } else {
      navigate('/login');
    }
    onClose();
  };
  
  const handleSignup = () => {
    if (packageData) {
      const packageParams = new URLSearchParams({
        plan: packageData.plan,
        duration: packageData.duration,
        price: packageData.price.toString(),
        returnTo: 'booking'
      });
      navigate(`/signup?${packageParams.toString()}`);
    } else {
      navigate('/signup');
    }
    onClose();
  };
  
  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={e => e.stopPropagation()}>
        <button className="close-auth-modal" onClick={onClose}>&times;</button>
        <h2>Login or Sign Up Required</h2>
        <p>You must be logged in to continue booking.</p>
        <div className="auth-modal-actions">
          <button className="btn btn-primary" onClick={handleLogin}>Login</button>
          <button className="btn btn-secondary" onClick={handleSignup}>Sign Up</button>
        </div>
      </div>
    </div>
  );
};
export default AuthModal;
